<template>
  <DataGetter
    :url="url"
    :params="{
      ...baseParams,
      Country: countries,
      CODE_YEAR: year,
    }"
    :initialData="[]"
    v-slot="{ data }"
    @fetched="setUnits"
    lazy
    :child-element-type="null"
  >
    <DataSlicer
      :data="data"
      :dataFormatter="sortData"
      yAxisDimension="Product"
      xAxisDimension="Country"
      valueDimension="Value"
      v-slot="{ slicedData }"
      @sliced="setProductName"
      :child-element-type="null"
    >
      <Chart
        :title="`${productName} prices, ${country} vs. selected countries and regions, ${year}`"
        :units="units"
        chartType="bar"
        :half="half"
        :series="slicedData"
        :chartOptions="{
          chart: {
            height: 400,
            spacing: 10,
            margin: [30, 0, 0, 200],
          },
          xAxis: {
            type: 'category',
            labels: {
              formatter() {
                return this.value === country
                  ? `<b>${this.value}</b>`
                  : this.value;
              },
            },
          },
          yAxis: {
            opposite: true,
            tickAmount: 6,
          },
        }"
      >
      </Chart>
    </DataSlicer>
  </DataGetter>
</template>

<script>
import { DataGetter, DataSlicer } from "@international-energy-agency/vue-ui";
import { Chart } from "@international-energy-agency/vue-ui/highcharts";
const comparitorCountries = [
  "Netherlands",
  "Italy",
  "Germany",
  "Australia",
  "Brazil",
  "G20",
  "People's Republic of China",
  "World",
  "United States",
  "Saudi Arabia",
  "Algeria",
  "France",
];
export default {
  components: { DataGetter, DataSlicer, Chart },
  props: {
    url: {
      type: String,
      default: "https://api.iea.org/prices",
      required: false,
    },
    country: {
      type: String,
      required: true,
    },
    sector: {
      type: String,
      default: "TRANS",
      required: false,
    },
    product: {
      type: String,
      default: "GASOLINE",
      required: false,
    },
    year: {
      type: String,
      required: false,
    },
    unit: {
      type: String,
      required: true,
    },
    half: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      units: " ",
      productName: "motor gasoline",
    };
  },
  computed: {
    baseParams() {
      const { product, sector, unit } = this;
      return {
        CODE_INDICATOR: "PRICE",
        CODE_PRODUCT: product,
        CODE_SECTOR: sector,
        CODE_UNIT: unit,
      };
    },
    countries() {
      const { country } = this;
      return comparitorCountries.includes(country)
        ? comparitorCountries
        : [country, comparitorCountries];
    },
  },
  methods: {
    setUnits(data) {
      this.units = data && data.length > 0 ? data[0].Unit : "&nbsp;";
    },
    setProductName(slicedData) {
      if (slicedData && slicedData.length > 0) {
        this.productName = slicedData[0].name;
      }
    },
    sortData(data) {
      return data.sort((a, b) => b.Value - a.Value);
    },
  },
};
</script>